import React, { useState } from 'react';

const Cell = ({ letter }) => {
  const [input, setInput] = useState('');

  const handleChange = (e) => {
    setInput(e.target.value.toUpperCase().slice(-1));
  };

  return (
    <input
      className={`cell ${input === letter ? 'correct' : ''}`}
      type="text"
      maxLength="1"
      value={input}
      onChange={handleChange}
    />
  );
};

export default Cell;
